import { Navigate, Route, Routes } from 'react-router-dom';
import { copy } from '../copy/es';
import { AdminShell } from './AdminShell';
import { CambioClavePage } from './paginas/CambioClavePage';
import { CarguePage } from './paginas/CarguePage';
import { ConfiguracionPage } from './paginas/ConfiguracionPage';
import { EntregasPage } from './paginas/EntregasPage';
import { IngresoPage } from './paginas/IngresoPage';
import { PublicacionPage } from './paginas/PublicacionPage';
import { UsuariosPage } from './paginas/UsuariosPage';
import { ProveedorSesion, useSesion } from './sesion';

function Protegido() {
  const { usuario, cargando } = useSesion();
  if (cargando) return <p className="p-8 text-gray-600">{copy.comun.cargando}</p>;
  if (!usuario) return <Navigate to="/admin/ingreso" replace />;
  if (usuario.debeCambiarClave) return <Navigate to="/admin/cambiar-clave" replace />;
  return <AdminShell />;
}

/** Admin area: sign-in, forced password change, and the shell with its sections. */
export function AdminApp() {
  return (
    <ProveedorSesion>
      <Routes>
        <Route path="ingreso" element={<IngresoPage />} />
        <Route path="cambiar-clave" element={<CambioClavePage />} />
        <Route element={<Protegido />}>
          <Route index element={<Navigate to="/admin/cargue" replace />} />
          <Route path="cargue" element={<CarguePage />} />
          <Route path="publicacion" element={<PublicacionPage />} />
          <Route path="entregas" element={<EntregasPage />} />
          <Route path="usuarios" element={<UsuariosPage />} />
          <Route path="configuracion" element={<ConfiguracionPage />} />
          <Route path="*" element={<p className="text-gray-600">{copy.comun.noEncontrado}</p>} />
        </Route>
      </Routes>
    </ProveedorSesion>
  );
}
